import { render, staticRenderFns } from "./SmartRampStart.vue?vue&type=template&id=dc67a178"
import script from "./SmartRampStart.vue?vue&type=script&lang=js"
export * from "./SmartRampStart.vue?vue&type=script&lang=js"
import style0 from "./SmartRampStart.vue?vue&type=style&index=0&id=dc67a178&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports